export const PAGE_TITLES: Record<string, string> = {
  dashboard: "대시보드",
  "seller-management": "셀러 관리",
  "order-management": "제품 주문 관리",
  "payment-management": "결제 관리",
  "settlement-management": "정산 관리",
  "product-list": "상품 목록",
  "product-edit": "상품 수정",
  "product-approval": "상품 등록",
  "review-management": "리뷰 관리",
  "product-tag-setting": "상품 태그 설정",
  "category-management": "카테고리 목록",
  "collection-management": "컬렉션 관리",
  "coupon-management": "쿠폰 관리",
  "popup-management": "팝업 관리",
  "banner-setting": "광고 배너 설정",
  "home-screen-setting": "홈 화면 설정",
  "customer-inquiry": "고객 문의",
  "seller-cs": "셀러 CS",
  "point-management": "포인트 관리",
  "cash-fund-management": "캐시 관리",
  "admin-management": "관리자 계정 관리",
  "certificate-list": "자격증 관리",
  "user-list": "사용자 목록",
  "brand-list": "브랜드 관리",
  "tour-approval": "투어 관리",
  "policy-management": "상품 정책관리",
  "class-list": "수강권 목록",
  "ticket-purchase-list": "수강권 구매 목록",
  "report-list": "신고글",
  "instructor-schedule-list": "강습 일정",
  "practice-schedule-list": "연습반 일정",
  "naver-order-register": "네이버 주문 등록",
  announcement: "공지사항 관리",
};

export const BREADCRUMB_PARENT: Record<string, string> = {
  "product-list": "상품",
  "product-edit": "상품",
  "product-approval": "상품",
  "review-management": "상품",
  "product-tag-setting": "상품",
  "category-management": "상품",
  "collection-management": "카테고리 관리",
  "coupon-management": "마케팅 관리",
  "popup-management": "마케팅 관리",
  "banner-setting": "마케팅 관리",
  "home-screen-setting": "마케팅 관리",
  "customer-inquiry": "고객 지원",
  "seller-cs": "고객 지원",
  "certificate-list": "회원 관리",
  "user-list": "회원 관리",
  "brand-list": "회원 관리",
  // 'tour-approval': '투어 관리'
  "policy-management": "상품",
  "class-list": "수강권",
  "ticket-purchase-list": "수강권",
  "report-list": "커뮤니티",
  "instructor-schedule-list": "스케쥴",
  "practice-schedule-list": "스케쥴",
  "naver-order-register": "주문관리",
  "order-management": "주문관리",
  announcement: "마케팅 관리",
};
